import React, { ReactElement } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MapState } from '../../map/reducer';
import { COORD_PATTERN, MEDLEM_ID_PATTERN, NODE_ID_PATTERN } from '../../../../utils';
import { decToDMX, getCoordinates } from '../../../../utils/geo';
import { UseParams } from '../../../../types';
import { MapRouterState } from '../../router/reducer';

export default function Breadcrumbs(): ReactElement {
  const { objects, pathname } = useSelector((state: { map: MapState; router: MapRouterState }) => ({
    objects: state.map.objects,
    pathname: state.router.path,
  }));
  const { slug }: UseParams = useParams();
  let title = '';
  let chartUrl = '/sjokort';
  let listpageCrumb;

  if (slug) {
    if (COORD_PATTERN.test(slug)) {
      const [lat, lon] = slug?.split(',') || [0, 0];
      title = getCoordinates(decToDMX(+lat, +lon));
    } else if (NODE_ID_PATTERN.test(slug) || MEDLEM_ID_PATTERN.test(slug)) {
      const item = objects?.find((i) => i.id === slug);
      if (item) {
        title = item.name;
        chartUrl = `/sjokort/${item.latitude},${item.longitude},17`;
        listpageCrumb = {
          url: `/sjokort/${item.type}`,
          title: item.typeName,
        };
      }
    } else {
      title = objects?.find((o) => o.type === slug)?.typeName || '';
    }
  }

  return (
    <>
      <li>
        <a href="/">Hem</a>
      </li>
      <li>
        &nbsp;<Link to={chartUrl}>Sjökort</Link>
      </li>
      {listpageCrumb && (
        <li>
          &nbsp;<Link to={listpageCrumb.url}>{listpageCrumb.title}</Link>
        </li>
      )}
      {title && pathname && (
        <li>
          &nbsp;<Link to={pathname}>{title}</Link>
        </li>
      )}
    </>
  );
}
